/* eslint-disable no-eval */
/*
const validators = {
  isCedula: (value) => validarRuc(value),
};
*/
export const processValidations = ({
  input,
  methods,
  beneficiarios = [],
  cotizacion,
  loading,
  setLoading,
}) => {
  if (input.customValidation) {
    //const isB64 = validator.isBase64(input.customValidation);
    //console.log(input.customValidation);
    //let strValidation = input.customValidation;
    /*
    if (isB64) {
      strValidation = decodeURIComponent(escape(window.atob(input.customValidation)));
    }
*/
    //const myValidation = eval(strValidation);

    input.rules.validate = {
      /*custom: async (value, event) => {
        return await myValidation(value, methods, beneficiarios, {
          axios,
          moment,
          validators,
          cotizacion,
          React,
          loader: { isLoading: loading, setLoading },
        });
      },*/
    };

    // input.rules.validate = async (value, event) => {
    //   return await myValidation(value, methods, beneficiarios, {
    //     axios,
    //     moment,
    //     validators,
    //     cotizacion,
    //     loader: { isLoading: loading, setLoading },
    //   });
    // };

    delete input?.longitud;
    delete input?.rules?.pattern;
  } else {
    input.length = parseInt(input.longitud);
  }

  return input.rules;
};

export const processDisabled = (input, loading) => {
  if (input.disabled) {
    return true;
  }
  return loading;
};

export const verifyInputTypeFromSelect = (name, inputs, setInputs, value) => {
  const changeInputType = (type = 'number') => {
    const index = inputs.findIndex((input) => input.codCore === 'identificacion');

    if (index !== -1) {
      const inputIdentificacion = inputs[index];
      inputIdentificacion.subType = type;
      inputs[index] = inputIdentificacion;

      setInputs([...inputs]);
    }
  };

  if (name === 'tipoIdentificacion' && value === 'pasaporte|PASAPORTE') {
    changeInputType('text');
  } else {
    changeInputType('number');
  }
};
